// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__vzrn4","selected":"Chip_selected__2V2Go"};